import { Component, OnInit } from '@angular/core';
// import { CspService } from './services/csp.service'; // Disabled - CSP now handled by .htaccess

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'base-app';

  constructor() {} // Removed CSP service injection

  ngOnInit() {
    // CSP is now handled by server-side .htaccess files
    // No need for client-side CSP meta tag manipulation
  }

  // Removed updateCspMetaTag method - not needed with .htaccess approach
}
